import '@cah/ecomm-nxtgen-pd-design-toolkit-web';
import('./App.js');